import { Lock01 } from "@untitledui/icons";

export function ForbiddenPage() {
    return (
        <div className="flex min-h-[60vh] flex-col items-center justify-center p-4 text-center">
            <div className="mb-5 flex h-14 w-14 items-center justify-center rounded-full bg-gray-100">
                <Lock01 className="h-7 w-7 text-gray-500" aria-hidden="true" />
            </div>
            <p className="text-sm font-semibold text-brand-600">403</p>
            <h1 className="mt-1 text-2xl font-semibold text-gray-900">Access denied</h1>
            <p className="mt-2 max-w-md text-md text-gray-600">
                You do not have permission to view this page. If you believe this is a mistake, contact your administrator.
            </p>
        </div>
    );
}
